const Line: Model = {
  name: 'lines',
  title: 'Production Lines',
  fields: [
    { name: 'name', label: 'Line', type: 'string', searchable: true },
  ],
};

export default Line;
